import store from '@/store';

const guard = async(to, from, next) => {
  if (to.params.admissionID === 'unidade') {
    const { name, params, query } = to;

    delete params.admissionID;

    store.commit('global/SET_UTM_ORIGIN', 'qrcode');
    store.commit('global/SET_AT_UNIT', true);

    next({
      name,
      params,
      query,
    });
  } else {
    const { utm_source: utmSource, utm_medium: utmMedium } = to.query;

    if (utmSource?.toLowerCase() === 'qrcode' && utmMedium?.toLowerCase() === 'senhas') {
      store.commit('global/SET_UTM_ORIGIN', 'qrcode');
    }

    next();
  }
};

export default guard;
